
<div class="cp-material">
  <div class="item" :class="[material === 'iphone' ? 'iphone' : material === 'mate60' ? 'mate60' : 'piying']"></div>
  <div class="desc">
    {{material === 'iphone' ? 'iPhone 15 x1' : material === 'mate60' ? '华为mate60 x1' : '端午礼盒套装x1'}}
  </div>
  <div class="action" @click="handleAddress"></div>
  <div class="rule">实物奖励将在填写地址后15个工作日内发放</div>
  <Close is-mobile @close="handleClose" class="close"></Close>
</div>
